import React from "react";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
export default function SinResultados(params){
    const _totalBusqueda= useStoreGlobal(useShallow((state) => state._totalBusqueda));
    const _totalBotonClic= useStoreGlobal(useShallow((state) => state._totalBotonClic));
    
    let texto=`No se encontraron resultados en la colección `;
    let textoTodo=`No se encontraron resultados.`;
    let sugere="Sugerencias:";
    let liPrimera="Asegúrate de que todas las palabras estén escritas correctamente.";
    let liSegunda="Intenta usar otras palabras.";
    let liTercero="Intenta usar palabras más generales.";
    let liMensaje="para buscar en todo da clic aquí.";

    let var_ingles = "es";
    if (window.location.href.indexOf("en.") > -1) {
        var_ingles = "en";
        textoTodo = "No results found.";
        texto=`No results found in the collection `;
        sugere = "Suggesting:";
        liPrimera ="Make sure all the words are spelled correctly.";
        liSegunda ="ry using different words.";
        liTercero ="Try using more general words.";
        liMensaje ="to search everything click here.";
    }
    let totalDatos = 0;
    if(Object.keys(_totalBusqueda).length > 0){
        totalDatos =_totalBusqueda.totalDatos;
    }
    let botonConsulta = 0;
    if(Object.keys(_totalBotonClic).length > 0){
        botonConsulta =_totalBotonClic.botonConsulta;
    }
    if(totalDatos === 0){
        if(document.getElementById('resultados')){
            document.getElementById('resultados').innerHTML= 0;
        }
    }
    function coleccionCambio(coleccion) {
        if(var_ingles !== "es"){
            switch (coleccion) {
                case "DENUE":    
                    coleccion = "DENUE";
                    break;
                case "Areageograficas":    
                    coleccion = "Geographic area";
                    break;
                case "Glosario":    
                    coleccion = "Glossary";
                    break;
                case "Indicadores":    
                    coleccion = "Indicators";
                    break;
                case "Infraestructura":    
                    coleccion = "Information infrastructure";
                    break;
                case "Programas":    
                    coleccion = "Information programs";
                    break;
                case "Investigación":    
                    coleccion = "Investigation";
                    break;
                case "Mapas":    
                    coleccion = "Maps";
                    break;
                case "Microdatos":    
                    coleccion = "Microdata";
                    break;
                case "Noticias":    
                    coleccion = "News";
                    break;
                case "Datos_abiertos":    
                    coleccion = "Open data";
                    break;
                case "Publicaciones":    
                    coleccion = "Publications";
                    break;
                case "Tabulados":    
                    coleccion = "Tabular data";
                    break;
                case "Herramientas":    
                    coleccion = "Tools";
                    break;
                case "Temas":    
                    coleccion = "Topics";
                    break;
                default:    
                    coleccion = "All";
                    break;
            }
            return coleccion 
        }
        coleccion = coleccion === "Datos_abiertos" ? "Datos abiertos" : coleccion;
        return coleccion;
    }
    const irTodo = () => {
        let selectElement = document.getElementById("selectPestana");
        const option = selectElement.querySelector(`option[value="Todo"]`);
        option.setAttribute('selected', 'selected');
        const event = new Event('change', { bubbles: true });
        selectElement.dispatchEvent(event);
    }
return(
    <>
        {
            botonConsulta ===1 && totalDatos === 0? (
                <div className="col-xs-12" id="snippet_resul" style={{display:"none"}}>
                    <span className="col-xs-12 col-sm-12" 
                            id="noResultadosPadre" 
                            style={{paddingBottom:"25px", top:"45px"}}>
                            {
                                params.coleccion !== "Todo" ? (
                                    <>
                                        {texto} <b>"{coleccionCambio(params.coleccion)}"</b> , <a id="Resultado_todo" style={{cursor:"pointer", color:"#00518b"}} onClick={() => irTodo()}>{liMensaje}</a>
                                    </>
                                ) :(<>{textoTodo}</>) 
                            }
                        <div id="noResultados">{sugere}
                            <ul id="listaNoResultados">
                                <li id="listaNoResultados">{liPrimera}</li>
                                <li id="listaNoResultados">{liSegunda}</li>
                                <li id="listaNoResultados">{liTercero}</li>
                            </ul>
                        </div>
                    </span>
                </div>
            ): ""
        }
    </>     
    )
}

